import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Upload, message, Spin, Form } from 'antd';
import Translate, { translate } from 'react-translate-component';
import { split, last, contains, dropLast, join } from 'ramda';
import PropTypes from 'prop-types';

import { generateImageUrl } from 'constants/urls';
import { openModalAvatar } from 'actions/modalActions';
import { MAX_FILE_SIZE } from 'constants/events';
import { formItemLayout } from 'constants/formItemLayout';

const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', function() {
        callback(reader.result);
    });
    reader.readAsDataURL(img);
};

const Plus = () => <span className="profile-plus-upload">{'+'}</span>;

const getFileName = (file) => file.name.indexOf('.') === -1 ? file.name : join('.', dropLast(1, split('.', file.name)));
const getFileType = (file) => last(split('/', file.type));

const allowedFormats = ['image/jpeg', 'image/png'];

const validateFile = ({ type: fileType, size }) => {
    let valid = true;
    if (size > MAX_FILE_SIZE) {
        message.error(translate('errors.exceededAllowedSize', { size: 32 }), 3);
        valid = false;
    }

    if (!contains(fileType, allowedFormats)) {
        message.error(translate('errors.wrongFiletype', { fileType }), 3);
        valid = false;
    }

    return valid;
};

@connect(null, { openModalAvatar })
export default class ProfileUploadAvatar extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        openModalAvatar: PropTypes.func.isRequired,
    }

    state = {
        loading: false,
        name: null,
        fileType: null
    }

    beforeUpload = (file) => {
        const validateResult = validateFile(file);

        if (validateResult) {
            this.setState({ loading: true });

            getBase64(file, imageUrl => {
                this.setState({ loading: false });

                this.props.openModalAvatar({
                    imageUrl,
                    name: getFileName(file),
                    fileType: getFileType(file)
                });

                return false;
            });
        }

        return false;
    }

    renderUploadButton() {
        return (
            <div className="profile-avatar-nophoto">
                { this.state.loading ? <Spin spinning={true} /> : <Plus/> }
                <div className="ant-upload-text">
                    <Translate content="profile.upload" />
                </div>
            </div>
        );
    }

    render() {
        const { user: { photo } } = this.props;
        const imageUrl = photo ? generateImageUrl(photo) : null;

        return (
            <Form.Item className="m-t-20" label={<Translate content="profile.avatar" />} {...formItemLayout}>
                <div className="profile-avatar-dragger">
                    <Upload.Dragger
                        name="avatar"
                        listType="picture-card"
                        className="profile-avatar-uploader"
                        showUploadList={false}
                        beforeUpload={this.beforeUpload}
                        onChange={this.onChange}
                    >
                        <div className="upload-area">
                            { imageUrl ? <img src={imageUrl} alt=""/> : this.renderUploadButton() }
                        </div>
                    </Upload.Dragger>
                </div>
            </Form.Item>
        );
    }
}
